var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("h3", { staticClass: "page-heading" }, [_vm._v("Dashboard")]),
      _vm._v(" "),
      _c("div", { staticClass: " clsContainer" }, [
        _c("div", { staticClass: "row mainStory" }, [
          _c("div", { staticClass: "col-md-4 card_item card__item" }, [
            _c(
              "div",
              {
                staticClass: "decisionTree",
                on: {
                  click: function($event) {
                    return _vm.goDecisionTree("mainStoryView")
                  }
                }
              },
              [_c("h5", [_vm._v("Decision Tree")])]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4 card__item" }, [
            _c(
              "div",
              {
                staticClass: "decisionTree",
                on: {
                  click: function($event) {
                    return _vm.goSettings()
                  }
                }
              },
              [_c("h5", [_vm._v("Settings")])]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4 card__item" }, [
            _c(
              "div",
              {
                staticClass: "decisionTree",
                on: {
                  click: function($event) {
                    return _vm.goDecisionTree("globalLogicEditView")
                  }
                }
              },
              [_c("h5", [_vm._v("Global Logic")])]
            )
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2)
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 card__item" }, [
      _c("div", { staticClass: "decisionTree clsBottom" }, [
        _c("h5", [_vm._v("Moodboard")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 card__item" }, [
      _c("div", { staticClass: "decisionTree clsBottom" }, [
        _c("h5", [_vm._v("\n              Assets\n            ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 card__item" }, [
      _c("div", { staticClass: "decisionTree clsBottom" }, [
        _c("h5", [_vm._v("Overlay")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c7e27396", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7e27396","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProjectDashboard.vue
// module id = null
// module chunks = 